import { Injectable } from '@angular/core';
import { Observable, filter, map } from 'rxjs';

import { CollectionGroup, TemplateGroup } from '../../domain/models/collection.models';
import { CollectionList } from '../../domain/models/collection.state';
import { CollectionCommandsFacade } from '../facades/commands/collection-commands.facades';
import { CollectionQueriesFacade } from '../facades/queries/collection-queries.facades';

@Injectable()
export class CollectionPublicPort {
    constructor(
        private readonly collectionQueriesFacade: CollectionQueriesFacade,
        private readonly collectionCommandsFacade: CollectionCommandsFacade,
    ) { }

    // TODO ECOMDUTI-29270 [DeudaTecnica] Delete getCollectionCms$
    public getCollectionCms$(slug: string): Observable<TemplateGroup[]> {
        return this.collectionQueriesFacade.getCollection$().pipe(
            filter(list => !!list),
            map(list => list[slug])
        ) as Observable<TemplateGroup[]>;
    }

    // TODO ECOMDUTI-29270 [DeudaTecnica] Delete as as Observable<CollectionGroup[]>
    public getCollection$(slug: string): Observable<CollectionGroup[]> {
        return this.collectionQueriesFacade.getCollection$().pipe(
            filter(list => !!list),
            map(list => list[slug])
        ) as Observable<CollectionGroup[]>;
    }

    public getListCollectionsCms$(): Observable<CollectionList> {
        return this.collectionQueriesFacade.getCollection$().pipe(
            filter(list => !!list),
        );
    }

    public getCollectionApi(collection: string): void {
        this.collectionCommandsFacade.getCollectionApi(collection);
    }
}
